import React, { useRef, useState} from 'react';
import { HbrPauseIcon, HbrPlayButton } from '../newComponents/Mycustomsvgicons';
import { formatMediaTime } from '../newComponents/GeneralClasses';

const ChatAudioPlayer = ({ audioUrl, mediaDuration}) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);

    const togglePlayPause = () => {
        if (audioRef.current.paused) {
            audioRef.current.play();
            setIsPlaying(true);
        } else {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const handleEnded=()=>{
        setIsPlaying(false);
    }

    const handleSeek = (event) => {
        audioRef.current.currentTime = event.target.value;
        setCurrentTime(event.target.value);
    };

    return (
        <div className='chataudioplayer flex-column2'>
            <audio
                ref={audioRef}
                src={audioUrl}
                onEnded={handleEnded}
                onTimeUpdate={handleTimeUpdate}
                style={{display:"none"}}
            />
            <div className="flex-row2" style={{width:"90%"}}>
                {!isPlaying ? 
                <HbrPlayButton width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={togglePlayPause}/>
                :
                <HbrPauseIcon width={"2em"} height={"2em"} fillColour={"#ffffff"} handleClick={togglePlayPause}/>
                }
             
                <input
                type="range"
                min="0"
                max={mediaDuration}
                value={currentTime}
                onChange={handleSeek}
                style={{width:"80%"}}
                /> 
         
            </div>

            <p style={{color:"white", fontWeight:"bold"}}>{`${formatMediaTime(currentTime)} / ${formatMediaTime(mediaDuration)}`}</p>
        </div>
    );
};
export default ChatAudioPlayer;